module.exports = __webpack_public_path__ + "media/WhiteNoise.92be14e8.wav";